import { render, staticRenderFns } from "./SingleCoupon.vue?vue&type=template&id=18ccc624&scoped=true&"
import script from "./SingleCoupon.vue?vue&type=script&lang=ts&"
export * from "./SingleCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./SingleCoupon.vue?vue&type=style&index=0&id=18ccc624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ccc624",
  null
  
)

export default component.exports